ACC.common = {

  refreshScreenReaderBuffer: function() {
    $('#accesibility_refreshScreenReaderBufferField').attr('value', new Date().getTime());
  },

  bindAll: function() {
    ACC.common.bindToUiCarouselLink();
    ACC.common.headerForMultiline();
  },
  headerForMultiline: function() {
    var pageType = '.pageType-CategoryPage h1.p-alternate-title';

    if ($(pageType).height() > 54 && $(pageType).length !== 0) {
      $(pageType).css('top', '150px');
    }
  },

  bindToUiCarouselLink: function() {
    $('ul.carousel > li a.popup').colorbox({
      onComplete: function() {
        ACC.common.refreshScreenReaderBuffer();
      },

      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });
  },

  bindShowProcessingMessageToSubmitButton: function() {
    $(':submit.show_processing_message').each(function() {
      $(this).on('click', ACC.common.showProcessingMessageAndBlockForm);
    });
  },
  refreshSelectBoxArrow: function() {
    $('.selectBox-arrow').each(function() {
      if ($(this).closest('form').hasClass('ph-dropdown-arrow-down')) {
        $(this).hide();
      } else {
        $(this).show();
      }
    });
  },
  showProcessingMessageAndBlockForm: function() {
    var form = $(this).parents('form:first'),
        $processingMessage = $('<img src=\'' + ACC.config.commonResourcePath + '/philipsUI/src/images/spinner.gif\'/>');

    form.block({
      message: $processingMessage
    });
  },
  blockFormAndShowProcessingMessage: function(submitButton) {
    var form = submitButton.parents('form:first'),
        $processingMessage = $('<img src=\'' + ACC.config.commonResourcePath + '/philipsUI/src/images/spinner.gif\'/>');

    form.block({
      message: $processingMessage
    });
  },
  recentOrdersHomeComponent: function() {
    $.ajax({
      url: ACC.config.contextPath + 'getRecentOrders.json',
      type: 'GET',
      dataType: 'json',
      success: function(data) {
        var allRecentData = data.recentOrdersToBeShown,
            rowData = '',
            trackingDetailsMap = data.trackingDetailsMap,
            trackingDetailMapArr = [];

        for (var trackingDetailMap in trackingDetailsMap) {
          if (trackingDetailsMap) {
            trackingDetailMapArr[trackingDetailMap] = trackingDetailsMap[trackingDetailMap];
          }
        }

        if (allRecentData) {
          allRecentData.forEach(function(recentData) {
            var status = recentData.statusCode,
                orderId = recentData.code,
                sapOrderId = '',
                noOfShipments = trackingDetailMapArr[recentData.code],
                recentOrdersNumber = $('#recentOrdersNumber').val(),
                showHybrisOrderNumber = data.showHybrisOrderNumber;

            var noOfshipment = ACC.common.showNoOfShipments(noOfShipments);

            var stringDate = recentData.stringDate,
                statusColor = recentData.status.code.replace(/_/g, ' ');

            statusColor = statusColor.charAt(0).toUpperCase() + statusColor.slice(1).toLowerCase();

            if (recentData.sapOrderId && recentData.code !== recentData.sapOrderId) {
              sapOrderId = recentData.sapOrderId;
              orderId = ' (' + recentData.code + ')';
            }

            var bothordid = '',
                differentOrdId = recentData.sapOrderId && recentData.code !== recentData.sapOrderId;

            if (showHybrisOrderNumber === true) {
              bothordid = sapOrderId + orderId;
            } else if (differentOrdId === true && showHybrisOrderNumber === false) {
              bothordid = sapOrderId;
            } else {
              bothordid = orderId;
            }

            rowData = '<a class="ph-introRecentOrder" href="/my-account/orders#' + recentData.code + '"><div class="ph-row_wrapper ph-col-12 ph-float-left">' +
            '<div class="ph-col-12 ph-col-sm-3 ph-float-left"><span class="ph-order_code_text">' + recentOrdersNumber + ':</span><span class="ph-order_code">' + bothordid +
            '</span></div><div class="ph-col-6 ph-col-sm-2 ph-p-sm-0 ph-float-left">' + stringDate +
            '</div><div class="ph-col-6 ph-col-sm-2 ph-float-left">' + recentData.totalPriceWithTax.formattedValue +
            '</div><div class="ph-col-2 ph-d-none ph-d-sm-block ph-float-left ph-ordernum__ordernumberlabel"><img class="ph-delivery_shipping ph-shipping_icon_' +
            recentData.code + '" src=\'' + ACC.config.commonResourcePath + '/philipsUI/src/images/delivery-truck-shipping.png\'/>' + noOfshipment +
            '</div><div class="ph-col-12 ph-col-sm-3 ph-float-left"><span class="ph-delivery_status ph-delivery_status_' + recentData.code +
            '"></span>' + status + '</div></div></a>';
            $('.ph-recent_orders_wrapper').append(rowData);
            ACC.common.addAttrIntro();

            ACC.common.bindColorCode(statusColor, recentData.code);

            ACC.common.noofShipment(recentData.code, noOfshipment);
          });
        }

        ACC.common.bindIntroRecentOrders();
        ACC.common.gaTaggingRecentOrders();
      }
    });
  },
  addAttrIntro: function() {
    var $introRecentHeader = $('.ph-recent_header'),
        introText = '<div class="ph-introjs__header ph-plp-introheader">' + $introRecentHeader.attr('data-introRecentHeader') +
                    '</div><div class="ph-introjs__text ph-plp-introtext">' + $introRecentHeader.attr('data-introRecentText') + '</div>';

    $introRecentHeader.attr('data-step', $introRecentHeader.attr('data-stepRecentOrder'));
    $introRecentHeader.attr('data-intro', introText);
  },
  bindIntroRecentOrders: function() {
    var noPopup = sessionStorage.getItem('changePasswordPopup');

    if ($('.ph-introjsvalue').text() === 'true' && $('.ph-page-homepage').length > 0) {
      if ($('.ph-showIntroToUser').text() === 'true' && (noPopup === 'false' || $('.ph-encodedType').attr('data-encodeValue') !== 'true')) {
        ACC.introjs.bindFunction();
      }
    }
  },
  gaTaggingRecentOrders: function() {
    if ($(document).find('.ph-recent_orders_wrapper > a').length > 0) {
      window.gaclkFn.linksOnclickGaEvent('.ph-recent_orders_wrapper > a', 'recent_orders');
      window.gaclkFn.linksOnclickGaEvent('.ph-recent_orders_wrapper .ph-all_orders > a', 'recent_orders');
    }
  },
  noofShipment: function(recentDataCode, noOfshipment) {
    if (noOfshipment === '') {
      $('.ph-shipping_icon_' + recentDataCode).addClass('hidden');
    }

    $('.ph-recent_orders_wrapper').removeClass('hidden');
  },
  introSearchHomePage: function() {
    if ($('.ph-introjsvalue').text() === 'true' && $('.ph-showIntroToUser').text() === 'true') {
      var $introsearch = $('.ph-searchparent__input'),
          introSearch = '<div class="ph-introjs__header">' + $introsearch.attr('data-introsearchheader') +
                         '</div><div class="ph-introjs__text">' + $introsearch.attr('data-introsearchtext') + '</div>',
          $introiconheader = $('.ph-headerparent__humanicon'),
          introIcon = '<div class="ph-introjs__header">' + $introiconheader.attr('data-iconintroheader') +
                       '</div><div class="ph-introjs__text">' + $introiconheader.attr('data-iconintrotext') + '</div>',
          $introIconInput = $('.ph-headerparent__humanicon.ph-loggedIn'),
          dataStep = 'data-step',
          dataIntro = 'data-intro';

      if ($('.srcTooltipIntroJs').text().split('-')[0] !== 'hhs') {
        $introsearch.attr(dataStep, $introsearch.attr('data-stepNumber'));
        $introsearch.attr(dataIntro, introSearch);
      }

      $introIconInput.attr(dataStep, $introiconheader.attr('data-stepNumber'));
      $introIconInput.attr(dataIntro, introIcon);
    }
  },
  showNoOfShipments: function(noOfShipments) {
    var noOfShipment = noOfShipments,
        shipmentLabel = $('.ph-shipment-label').text(),
        shipmentsLabel = $('.ph-shipments-label').text();

    if (noOfShipment === 0) {
      noOfShipment = '';
    } else if (noOfShipment === 1) {
      noOfShipment = '1 ' + shipmentLabel;
    } else {
      noOfShipment = noOfShipment + ' ' + shipmentsLabel;
    }

    return noOfShipment;
  },
  /* eslint-disable complexity */
  bindColorCode: function(status, recentCode) {
    var statusVal = status.toLowerCase(),
        $deliveryStatus = $('.ph-delivery_status_' + recentCode);

    if (statusVal.indexOf('error') > -1) {
      statusVal = 'error';
    }

    switch (statusVal) {
        case 'created':
        case 'authorization sent':
        case 'authorization success':
        case 'payment captured':
        case 'payment not captured':
        case 'payment capture sent':
        case 'payment capture success':
        case 'refund success':
        case 'refund sent':
        case 'fraud checked':
        case 'checked valid':
        case 'checked invalid':
        case 'payment authorized':
        case 'suspended':
        case 'partial return submitted':
        case 'refund sync failure':
        case 'refund async failure':
        case 'payment capture sync failure':
        case 'payment capture async failure':
        case 'wait fraud manual check':
        case 'order split':
        case 'payment not authorized':
        case 'authorization sync failure':
        case 'authorization async failure':
        case 'payment amount not reserved':
        case 'processing':
          $deliveryStatus.addClass('ph-CREATED');

          break;

        case 'error':
        case 'cancelled':
        case 'canceled':
        case 'processing error':
        case 'philips system error':
        case 'b2b processing error':
          $deliveryStatus.addClass('ph-CANCELLED');

          break;

        case 'completed':
        case 'delivered':
        case 'payment amount reserved':
          $deliveryStatus.addClass('ph-COMPLETED');

          break;

        case 'cancelling':
        case 'partially invoiced':
          $deliveryStatus.addClass('ph-PARTIALLY_INVOICED');

          break;

        case 'return order':
        case 'returned':
        case 'partially returned':
        case 'return cancelled':
        case 'return in progress':
          $deliveryStatus.addClass('ph-RETURN_ORDER');

          break;

        case 'assigned to admin':
        case 'assign admin':
          $deliveryStatus.addClass('ph-ASSIGN_ADMIN');

          break;

        case 'shipped':
          $deliveryStatus.addClass('ph-SHIPPED');

          break;

        case 'rejected':
          $deliveryStatus.addClass('ph-REJECTED');

          break;

        case 'pending approval':
          $deliveryStatus.addClass('ph-PENDING_APPROVAL');

          break;

        case 'invoiced':
          $deliveryStatus.addClass('ph-INVOICED');

          break;

        default:
          $deliveryStatus.addClass('ph-DEFAULT');
    }
  },
  /* eslint-enable complexity */
  addSearchBox: function($element) {
    var $el = $('.selectBox-dropdown-menu.selectBox-options.selectBox-options-bottom'),
        searchText = $('#selectSearchText').val(),
        noResultText = $('#selectSearchNoResult').val(),
        $searchBox = $('<div class="selectBox-options ph-selectSearch"><input type="text" placeholder="' + searchText + '"></div>'),
        $listAll = $el.find('li:not(.ph-selectSearch_noresult):not(.selectBox-disabled)'),
        groupName = '',
        searchLength = parseInt($('#selectSearchLength').val(), 10) || 1;

    $element.before($searchBox);
    $searchBox.css('width', $el.width());
    $listAll.each(function() {
      if ($(this).hasClass('selectBox-optgroup')) {
        groupName = $(this).text();
      }

      $(this).attr('data-group', groupName);
    });
    $searchBox.find('input').on('keyup', function() {
      var $elm = $(this),
          val = $elm.val().toLowerCase(),
          lists = $el.find('li:not(.selectBox-optgroup):not(.ph-selectSearch_noresult):not(.selectBox-disabled)'),
          $noresult = $el.find('.ph-selectSearch_noresult');

      if (val.length >= searchLength) {
        $el.find('li.selectBox-disabled, li.selectBox-optgroup').hide();
        lists.each(function() {
          var $listElm = $(this),
              listText = $listElm.html().toLowerCase();

          if (listText.indexOf(val) !== -1 || listText === val) {
            $listElm.show();
            $el.find('li.selectBox-optgroup[data-group="' + $listElm.attr('data-group') + '"]').show();
          } else {
            $listElm.hide();
          }
        });

        if (lists.find(':visible').length > 0) {
          $noresult.remove();
        } else if ($noresult.length === 0) {
          $el.append('<li class="ph-selectSearch_noresult">' + noResultText + '</li>');
        } else {
          $noresult.show();
        }
      } else {
        $listAll.show();
        $el.find('li.selectBox-disabled').show();
        $noresult.remove();
      }
    });
  },
  removeSearchBox: function() {
    var $el = $('.selectBox-dropdown-menu.selectBox-options.selectBox-options-bottom');

    $('.ph-selectSearch').remove();
    $el.find('li').removeAttr('style');
    $el.find('.ph-selectSearch_noresult').remove();
  },
  searchSelectInit: function() {
    var searchCount = parseInt($('#selectSearchCount').val(), 10) || 5;

    $('.ph-configuration-popup .ph-common-configselect').each(function() {
      if ($(this).find('option:not(:disabled)').length >= searchCount) {
        $(this).selectBox({
          mobile: true
        }).on('beforeopen', function() {
          ACC.common.addSearchBox($(this));
          ACC.imgLazyLoad.setImageObserver();
        }).on('close', function() {
          ACC.common.removeSearchBox();
        });
      } else {
        $(this).selectBox();
        ACC.imgLazyLoad.setImageObserver();
      }
    });
  }
};

$(document).ready(function() {
  ACC.common.bindAll();
  ACC.common.bindShowProcessingMessageToSubmitButton();

  var recentOrderWrapper = '.ph-recent_orders_wrapper';

  if ($('.ph-page-homepage').length > 0) {
    if ($(recentOrderWrapper).length > 0) {
      ACC.common.recentOrdersHomeComponent();
    }

    ACC.common.introSearchHomePage();
  }

  $('textarea[maxlength]').on('keyup blur', function() {
    var maxlength = $(this).attr('maxlength');
    var val = $(this).val();

    if (val.length > maxlength) {
      $(this).val(val.slice(0, maxlength));
    }
  });

  if ($('body').hasClass('ph-page-register')) {
    document.forms.registerForm.elements[0].focus();
  }

  if ($('body').hasClass('ph-page-updatePassword')) {
    document.forms.updatePwdForm.elements[0].focus();
  }

  if ($('.ph-homepage__topcategories--card').length > 0) {
    $('.ph-homepage__topcategories--main').show();
  } else {
    $('.ph-homepage__topcategories--main').hide();
  }
});
$(window).on('load', function() {
  var orderId = window.location.hash;

  if (orderId) {
    orderId = orderId.slice(1);
    $('.ph-orderhistory_title').each(function() {
      if ($(this).attr('data-orderid') === orderId) {
        $(this).parent().trigger('click');
      }
    });
  }

  setTimeout(function() {
    ACC.common.refreshSelectBoxArrow();

    if ($('.ph-add2cart-formload').length > 0) {
      $('.ph-add2cart-formload').removeClass('ph-add2cart-formload');
    }
  }, 1000);
});
